import React from "react";
import styles from "./input.module.css";

const TextInput = ({ placeholder, type, min, step, value, onChange, isEmpty, useValidation, validator, hidden, autocomplete='on' }) => {

  return (
    <div className={type==='text' && !isEmpty ? styles.inputWrapperEmpty : styles.inputWrapper}>
      <input
        className={type==='email' && useValidation && !validator.test(value) ? styles.error : styles.success}
        type={type}
        min={min}
        step={step}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        hidden={hidden}
        autoComplete={autocomplete}
      />
    </div>
  );
};

export default TextInput;
